import type { HttpTypes } from '@medusajs/types';

import { getPricesForVariant } from '@lib/util/get-product-price';
import Text from '@modules/common/components/text';

interface LineItemUnitPriceProps {
  item: HttpTypes.StoreCartLineItem | HttpTypes.StoreOrderLineItem;
  style?: 'default' | 'tight';
  isCashOnly?: boolean;
}

const LineItemUnitPrice = ({
  item,
  style = 'default',
  isCashOnly = false,
}: LineItemUnitPriceProps) => {
  const prices = getPricesForVariant(item.variant);
  const hasReducedPrice =
    (prices?.calculated_price_number ?? 0) < (prices?.original_price_number ?? 0);

  return (
    <div className="text-ui-fg-muted flex h-full flex-col justify-center">
      {hasReducedPrice && (
        <>
          <p>
            {style === 'default' && (
              <span className="text-ui-fg-muted">Original: </span>
            )}
            <span
              className="line-through"
              data-testid="product-unit-original-price"
            >
              {prices?.original_price}
            </span>
          </p>
          {style === 'default' && (
            <span className="text-ui-fg-interactive">
              -{prices?.percentage_diff}%
            </span>
          )}
        </>
      )}
      <Text
        variant="body-bold"
        as="span"
        className="text-black-30"
        data-testid="product-unit-price"
      >
        進價 {prices?.calculated_price}
        {isCashOnly && (
          <span className="ml-2 inline-block whitespace-nowrap rounded border border-[#dcd7c5] bg-[#efebe0] px-2 py-[3px] text-xs font-medium tracking-wide text-[#9b7c53]">
            不適用回饋金
          </span>
        )}
      </Text>
      <Text variant="body-regular" as="span" data-testid="product-suggested-price">
        建議售價 {prices?.suggested_price}
      </Text>
      <Text variant="body-regular" as="span" data-testid="product-member-price">
        會員通路價 {prices?.member_price}
      </Text>
    </div>
  );
};

export default LineItemUnitPrice;
